import React from 'react'

import { Link } from 'gatsby'

import { WpMenuType } from '@contracts/Components/Wordpress'

import { flatListToHierarchical } from '../../utils/utils'
import * as styles from './WordpressMenu.module.scss'

import CaretDown from '@images/caret-down.svg'

interface Props {
	data: WpMenuType
	className?: string
}

const WordpressMenu = (props: Props) => {
	const structuredMenu = flatListToHierarchical(props.data.nodes)

	const menuStyles = [styles.menu]

	if (props.className) {
		menuStyles.push(props.className)
	}

	const toggleSubMenu = (e: React.BaseSyntheticEvent<object, any, HTMLElement | null>) => {
		let label = e.target

		if (label) {
			if (label.tagName !== 'SPAN') {
				if (label.closest('span')) {
					label = label.closest('span')
				}
			}

			if (label) {
				const subMenu: Element | null = label.nextElementSibling

				label.classList.toggle('active')

				if (subMenu) {
					subMenu.classList.toggle('active')
				}
			}
		}
	}

	return (
		<ul className={menuStyles.join(' ')}>
			{structuredMenu.map((item) => {
				return (
					<li key={item.id} className={styles.menuItem}>
						{item.path == '#' && item.children && item.children.length > 0 ? (
							<>
								<span
									onClick={(e: React.BaseSyntheticEvent) => toggleSubMenu(e)}
									className={styles.label}
								>
									{item.label}{' '}
									<i>
										<CaretDown />
									</i>
								</span>

								<ul className={styles.subMenu}>
									{item.children.map((child) => {
										return (
											<li key={child.id} className={styles.menuItem}>
												<Link to={child.path}>{child.label}</Link>
											</li>
										)
									})}
								</ul>
							</>
						) : (
							<Link to={item.path}>{item.label}</Link>
						)}
					</li>
				)
			})}
		</ul>
	)
}

export default WordpressMenu
